<script setup>
import Banners from '@/components/Banners.vue';
import MyLoadsDesktopMainComponent from '@/components/myLoads/MyLoadsDesktopMainComponent.vue';
</script>

<template>
  <div class="this-test">
    <banners
      :sticky-top="true"
      :narrow="true"
      :is-ultra="true"
    >
      <MyLoadsDesktopMainComponent />
    </banners>
  </div>
</template>
